import React, { Fragment, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Button, Card, CardBody, Col, CardFooter, Row } from "reactstrap";
import { ReactComponent as AddIcon } from "../../../assets/utils/images/svgs/addBlue.svg"
import PageHeading from "Layout/AppMain/PageHeading";
import List from "./List";

const Default = () => {
    const [showModal, setShowModal] = useState(false);
    return (
        <Fragment>
            <PageHeading />
           <TransitionOnLoad>
                    <div>
                        <Row>
                            <Col md="12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3">
                                        <List showModal={showModal} setShowModal={setShowModal} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </TransitionOnLoad>

            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <Button
                        outline
                        className="btn-outline-primary-blue btn-color-style d-flex justify-content-center align-items-center gap-2"
                        onClick={() => setShowModal(true)}
                        type="button"
                        color="primary"
                    >
                        Gebruiker <AddIcon />
                    </Button>
                </CardFooter>
            </div>
        </Fragment>
    )
};

export default Default;